<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import "vue-select/dist/vue-select.css";
import Vuetable from "vuetable-2";

import Toasted from "vue-toasted";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
// Lets Register a Global Error Notification Toast.

Vue.use(Toasted);
/**
 * Departamento component
 */
export default {
  page: {
    title: "Información de la compra",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Vuetable },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      stock: [],
      url: 0,
      iddetalle: 0,
      cantidad: 0,
      idstock: 0,
      idubicacion: 0,
      formPro: {
        factura: "",
        fecha_orde: "",
        direccionp: "",
        empleado: "",
        usuarioa: "",
        usuarioo: "",
        no_orden: "",
        observaciones: "",
        nit_proveedor: "",
        no_compra: "",
        fecha_compra: "",
        fecha_orden: "",
        fecha_credito: "",
        tienda: "",
        proveedor: "",
        total: "",
        state: true,
        credito: true,
        id: 0,
      },
      detalleorden: [],
      fields: [
        {
          name: "opciones",
          sortField: "opciones",
          title: "opciones",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "5%",
        },
        {
          name: "producto.nombre_producto",
          sortField: "producto.nombre_producto",
          title: "Nombre",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "25%",
        },
        {
          name: "producto.codigo_stock",
          sortField: "producto.codigo_stock",
          title: "Código",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "25%",
        },
        {
          name: "cantidad_compra",
          sortField: "cantidad_compra",
          title: "Cantidad",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "precio_compra",
          sortField: "precio_compra",
          title: "Precio Compra",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },

        {
          name: "subtotal",
          sortField: "subtotal",
          title: "Subtotal",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "ubicacion",
          sortField: "ubicacion",
          title: "Ubicación",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "25%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "20%",
        },
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
      },
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      formget: {
        nombre: "",
        state: true,
      },
      formSub: {
        nombre: "",
        cantidaddepa: "",
        state: true,
        id: 0,
      },
      updating: false,
      title: "Información",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Información",
          active: true,
        },
      ],
      loadingtable: false,

      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES

    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date)
        .locale("es")
        .utc()
        .format("MMM Do YYYY");
    },
    detalle() {
      axios
        .get(
          process.env.VUE_APP_URL +
            "compras/view_compra?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          console.log(response);
          this.formPro.observaciones = response.data.compra.observaciones;
          this.detalleorden = response.data.compra.detalle_compras;
          this.formPro.empleado =
            response.data.compra.user.empleado.persona.nombre_persona +
            " " +
            response.data.compra.user.empleado.persona.apellido_persona;
          this.formPro.nit_proveedo =
            response.data.compra.proveedore.nit_proveedor;
          this.formPro.proveedor =
            response.data.compra.proveedore.company_proveedor;
          this.formPro.no_compra = response.data.compra.no_documento_c;
          this.formPro.fecha_compra = this.showDate(
            response.data.compra.fecha_compra_c
          );
          this.formPro.fecha_entrega = this.showDate(
            response.data.compra.fecha_entrega_c
          );
          this.formPro.fecha_credito = this.showDate(
            response.data.compra.fecha_credito_c
          );
          this.formPro.total = response.data.compra.total_c;
          this.formPro.factura = response.data.compra.no_factura_c;
          this.formPro.direccionp =
            response.data.compra.proveedore.direccion_proveedor;
          this.formPro.state = response.data.compra.estado_pagado_c;
          this.formPro.credito = response.data.compra.estado_credito_c;
       

          //  console.log( this.detalleorden);
        });
    },
    autorizaIngreso() {
      const me = this;
      // console.log(this.iddetalle, this.cantidad,this.idstock,this.idubicacion)
      axios
        .put(process.env.VUE_APP_URL + "compras/autoriza", {
          iddeta: this.iddetalle,
          cantidad: this.cantidad,
          idstock: this.idstock,
          idubicacion: this.idubicacion,
        },{
            headers: { "x-token": this.userT.token}
          })
        .then( () => {
          Vue.toasted.success("Producto procesado", this.options);
          this.detalle();
          me.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          me.showModalD = false;
        });
    },
    onActionClicked(action, data) {
      console.log(data)
      if (action == "desactivate-item") {
        // console.log(data);
        (this.iddetalle = data.id),
          (this.cantidad = data.cantidad_compra),
          (this.idstock = data.productoId),
          (this.idubicacion = data.inventarioProductoId),
          // this.formSub.nombre=data.departamento.nombre_departamento;
          // this.formSub.id=data.id;
          // this.formSub.cantidaddepa=data.existencia_departamento;
          (this.showModalD = true);
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */

.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <!-- Modal para autorizar ingreso -->
        <b-modal
          centered
          v-model="showModalD"
          title="Desactivar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Autorizar el ingreso de producto?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="autorizaIngreso"
                >Autorizar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Fin modal autorizar ingreso -->
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->

        <!-- Modal para Desactivar -->
        <!--             <b-modal
              centered
              v-model="showModalD"
              title="Desactivar"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            
                         <h4>¿Desea Desactivar  {{this.formSub.nombre}}?</h4>
                            
                          </div>
                        </div>
                      
                       
                      </div>

                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalD = false">Cancelar</b-button>
                         <b-button variant="danger" @click="desactivate">Desactivar</b-button>
                      </div>
                    </form>
            </b-modal>
 -->

        <div class="card" style="margin-bottom: 0px;margin-top: 0px;">
          <div class="card-body" style=" padding-top: 0px;padding-bottom: 0px;">
            <div class="">
              <div class="row justify-content-center">
                <div class="">
                  <div class="text-center" >
                    <div class=""></div>
                    <h4 >Compra</h4>
                  </div>
                  <hr />
                  <div class="card" style="margin-bottom: 0px;margin-top: 0px;">
                    <div class="card-body" style=" padding-top: 0px;padding-bottom: 0px;">
                      <div class="text-center">
                        <div class="row">
                          <div class="col-sm-8 ">
                            <h4 class="card-title">Detalles de la compra</h4>
                          </div>

                          <div class="col-sm-4">
                            <div>
                              <router-link
                                :to="{
                                  name: 'compras',
                                }"
                              >
                                <b-button
                                  variant="outline-primary"
                                  type="button"
                                  class="btn btn-rounded mb-1 me-2"
                                >
                                  <i class="mdi mdi-arrow-collapse-left"></i>
                                  Regresar
                                </b-button>
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div role="tablist">
                        <b-card no-body class="mb-1 shadow-none">
                          <b-card-header header-tag="header" role="tab">
                            <h6 class="m-0">
                              <a
                                v-b-toggle.accordion-1
                                class="text-dark"
                                href="javascript: void(0);"
                                ><i
                                  class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                                ></i
                                >Detalles Generales</a
                              >
                            </h6>
                          </b-card-header>
                          <b-collapse
                            id="accordion-1"
                            visible
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-card-body style=" padding-top: 0px;padding-bottom: 0px;">
                              <b-card-text>
                                <div class="text-center">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <div>
                                        <p class="text-muted mb-2">Observaciones</p>
                                        <h5 class="font-size-15">
                                          {{ formPro.observaciones }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <div class="mt-4 mt-sm-0">
                                        <p class="text-muted mb-2">
                                          Estado Pagado
                                        </p>
                                        <h5 v-if="formPro.state == true">
                                          <span class="badge bg-success ms-1"
                                            ><strong>Pagado</strong></span
                                          >
                                        </h5>
                                        <h5 v-else>
                                          <span class="badge bg-danger ms-1"
                                            ><strong>Sin Pagar</strong></span
                                          >
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <div class="mt-4 mt-sm-0">
                                        <p class="text-muted mb-2">Crédito</p>
                                        <h5 v-if="formPro.credito == true">
                                          <span class="badge bg-danger ms-1"
                                            ><strong>Si</strong></span
                                          >
                                        </h5>
                                        <h5 v-else>
                                          <span class="badge bg-success ms-1"
                                            ><strong>No</strong></span
                                          >
                                        </h5>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="text-center">
                                  <div class="row">
                                    <div class="col-sm-3">
                                      <div>
                                        <p class="text-muted mb-2">Proveedor</p>
                                        <h5 class="font-size-15">
                                          {{ formPro.proveedor }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-3">
                                      <div class="mt-4 mt-sm-0">
                                        <p class="text-muted mb-2">
                                          No. Compra
                                        </p>
                                        <h5 class="font-size-15">
                                          {{ formPro.no_compra }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-3">
                                      <div class="mt-4 mt-sm-0">
                                        <p class="text-muted mb-2">Total</p>
                                        <h5 class="font-size-15">
                                          {{ money(formPro.total) }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-3">
                                      <div class="mt-4 mt-sm-0">
                                        <p class="text-muted mb-2">
                                          No. Factura
                                        </p>
                                        <h6
                                          v-if="formPro.user != ''"
                                          class="font-size-15"
                                        >
                                          {{ formPro.factura }}
                                        </h6>
                                        <h6 v-else class="font-size-15">
                                          Sin autorizar
                                        </h6>
                                      </div>
                                    </div>
                                    
                                  </div>
                                </div>
                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card>

                        <!-- <b-card no-body class="mb-0">
                          <b-card-header header-tag="header" role="tab">
                            <h6 class="m-0">
                              <a
                                v-b-toggle.accordion-2
                                class="text-dark"
                                href="javascript: void(0);"
                                ><i
                                  class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                                ></i
                                >Datos orden de compra</a
                              >
                            </h6>
                          </b-card-header>
                          <b-collapse
                            id="accordion-2"
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-card-body style=" padding-top: 0px;padding-bottom: 0px;">
                              <b-card-text>
                                <div class="mb-4">
                                  <a
                                    href="#"
                                    class="badge bg-dark font-size-12"
                                  >
                                    <i
                                      class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                                    ></i>
                                    Fecha Compra: {{ formPro.fecha_compra }}
                                  </a>
                                  <a
                                    href="#"
                                    class="badge bg-primary font-size-12"
                                  >
                                    <i
                                      class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                                    ></i>
                                    Fecha Entrega: {{ formPro.fecha_entrega }}
                                  </a>
                                  <a
                                    href="#"
                                    class="badge bg-light font-size-12"
                                    v-if="formPro.fecha_credito != ''"
                                  >
                                    <i
                                      class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                                    ></i>
                                    Fecha Crédito: {{ formPro.fecha_credito }}
                                  </a>
                                  <a
                                    href="#"
                                    class="badge bg-light font-size-12"
                                    v-else
                                  >
                                    <i
                                      class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                                    ></i>
                                    Fecha Crédito: Sin Fecha.
                                  </a>
                                  <a
                                    href="#"
                                    class="badge bg-success font-size-12"
                                  >
                                    <i
                                      class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                                    ></i>
                                    Fecha Orden: {{ formPro.fecha_orden }}
                                  </a>
                                </div>

                                <div class="text-center">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <div>
                                        <p class="text-muted mb-2">
                                          Usuario que autorizó.
                                        </p>
                                        <h5 class="font-size-15">
                                          {{ formPro.usuarioa }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <div class="mt-4 mt-sm-0">
                                        <p class="text-muted mb-2">
                                          No. Orden.
                                        </p>
                                        <h5 class="font-size-15">
                                          {{ formPro.no_orden }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <div class="mt-4 mt-sm-0">
                                        <p class="text-muted mb-2">
                                          Usuario que creo la orden.
                                        </p>
                                        <h5 class="font-size-15">
                                          {{ formPro.usuarioo }}
                                        </h5>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card> -->
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>

        <div class="card" style="margin-bottom: 0px;margin-top: 0px;">
          <div class="card-body" style=" padding-top: 0px;padding-bottom: 0px;">
            <h4 class="card-title">Listado de Existencias</h4>
            <div class="row ">
              <div class="col-sm-12 col-md-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center"> </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-mode="false"
                :fields="fields"
                :data="detalleorden"
              >
                <div slot="opciones" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      tabindex="0"
                      v-if="props.rowData.estado_traslado == true"
                      v-b-tooltip.focus
                      title="Autorizar  Ingreso"
                      variant="success default"
                      @click="
                        onActionClicked('desactivate-item', props.rowData)
                      "
                    >
                      <i class="bx bxs-add-to-queue check-nav-icon"></i>
                    </b-button>
                  </b-button-group>
                </div>
                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_detalle == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="subtotal" slot-scope="props">
                  {{ money(props.rowData.subtotal_compra) }}
                </div>
                <div slot="precio_compra" slot-scope="props">
                  {{ money(props.rowData.precio_compra) }}
                </div>
                <div slot="ubicacion" slot-scope="props">
                  {{ props.rowData.inventario_producto.bodega.nombre_bodega }}
                </div>
              </vuetable>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
